




import { Component, Prop, Vue } from 'vue-property-decorator';
import PropertyMedia from '@/components/property/PropertyMedia.vue';
import { SurveyProperty } from '@/api';
import { NavigationGuardNext, RawLocation, Route } from 'vue-router';

@Component({ components: { PropertyMedia } })
export default class PropertyFavourites extends Vue {
  @Prop({ required: true }) readonly property: SurveyProperty;

  async beforeRouteEnter(to: Route, from: Route, next: NavigationGuardNext) {
    if (to.query['has-favourites'] === undefined) {
      next({
        ...to,
        query: { ...to.query, 'has-favourites': 'true' },
      } as RawLocation);
    } else {
      next();
    }
  }
}
